export const getButtonText = (isNeedRequest?: boolean, isConstructor?: boolean, isPrivateSector?: boolean) => {
    switch (true) {
      case isNeedRequest:
        return 'Создать заявку';
      case isConstructor:
        return 'Собрать тариф';
      case isPrivateSector:
        return 'Подключить';
      default:
        return 'Подключить онлайн';
    }
  };
